<span class="c-option__text">
    <ng-content></ng-content>
</span>
<ihd-icon
    name="check"
    class="c-icon--xs"
    *ngIf="isSelected && !customSelect"
></ihd-icon>
